// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-detail__hero {
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: var(--pages-video-header-wrapper-bg-color);
}
.page-detail__hero-video-player {
  width: 100%;
  max-width: 1200px;
  height: 100%;
  padding: var(--pages-video-header-wrapper-v-padding) 0;
}
.page-detail__hero-video-player .player-container .video-js {
  height: 100% !important;
  padding-top: 0 !important;
}
.page-detail__hero-video-player .player-container .video-js .vjs-tech {
  object-fit: cover;
}
.page-detail__hero-video-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.page-detail__hero-media {
  width: 100%;
  height: 700px;
  object-fit: cover;
  display: none;
}
@media (min-width: 768px) {
  .page-detail__hero-media {
    display: block;
  }
}
.page-detail__hero-media-mobile {
  width: 100%;
  height: 700px;
  object-fit: cover;
  display: block;
}
@media (min-width: 768px) {
  .page-detail__hero-media-mobile {
    display: none;
  }
}
.page-detail__utils {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 0;
  justify-content: space-between;
}
.page-detail__utils-top {
  border-bottom: 1px solid var(--default-border-color);
}
.page-detail__utils-bottom {
  border-top: 1px solid var(--default-border-color);
}
@media (max-width: 1200px) {
  .page-detail__utils {
    padding: 40px 24px;
  }
}
.page-detail__content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
}
@media (max-width: 1200px) {
  .page-detail__content {
    padding: 40px 24px;
  }
}
.page-detail__title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 12px;
}
.page-detail__subtitle {
  font-size: 1.1rem;
  color: rgba(0, 0, 0, 0.55);
  margin-bottom: 24px;
}
.page-detail__body {
  font-size: 1rem;
  line-height: 1.7;
}
.page-detail__meta-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 20px;
}
.page-detail__meta-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(0, 0, 0, 0.45);
}
.page-detail__meta-value {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.85);
}
.page-detail__cta-button {
  color: var(--pages-cta-button-text-color) !important;
  background-color: var(--pages-cta-button-bg-color) !important;
  border-color: var(--pages-cta-button-border-color) !important;
}
.page-detail__cta-button:hover {
  color: var(--pages-cta-button-bg-color) !important;
  background-color: var(--pages-cta-button-text-color) !important;
}
.page-detail_focuson-list {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/PageDetail/PageDetail.scss"],"names":[],"mappings":"AAGI;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,4DAAA;AAFR;AAIQ;EACI,WAAA;EACA,iBAAA;EACA,YAAA;EACA,sDAAA;AAFZ;AAMY;EACI,uBAAA;EACA,yBAAA;AAJhB;AAMgB;EACI,iBAAA;AAJpB;AASQ;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AAPZ;AAWI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;AATR;AAWQ;EANJ;IAOQ,cAAA;EARV;AACF;AAWI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AATR;AAWQ;EANJ;IAOQ,aAAA;EARV;AACF;AAWI;EACI,aAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EAEA,8BAAA;AAVR;AAYQ;EACI,oDAAA;AAVZ;AAYQ;EACI,iDAAA;AAVZ;AAYQ;EAdJ;IAeQ,kBAAA;EATV;AACF;AAYI;EACI,iBAAA;EACA,cAAA;EACA,eAAA;AAVR;AAWQ;EAJJ;IAKQ,kBAAA;EARV;AACF;AAWI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AATR;AAYI;EACI,iBAAA;EACA,0BAAA;EACA,mBAAA;AAVR;AAaI;EACI,eAAA;EACA,gBAAA;AAXR;AAcI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAZR;AAeI;EACI,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;AAbR;AAgBI;EACI,eAAA;EACA,0BAAA;AAdR;AAiBI;EACI,oDAAA;EACA,6DAAA;EACA,6DAAA;AAfR;AAiBQ;EACI,kDAAA;EACA,+DAAA;AAfZ;AAmBI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAjBR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
